export default __webpack_public_path__ + "static/media/do-be-consistent.656d33a1.svg";